import { SxProps } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';

export const sidebarStyle: SxProps = {
  color: colorPalette.secondary.main,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};
